import { combineReducers } from 'redux';
import internalLinks from '../screens/InternalLinks/reducers';
import linksSetting from '../screens/LinksSetting/reducers';
import index from '../screens/Index/reducers';
import companyAdmin from '../screens/CompanyAdmin/reducers';
import companyNews from '../screens/CompanyNews/reducers';
import companyRules from '../screens/CompanyRules/reducers';
import departmentNews from '../screens/DepartmentNews/reducers';
import stickynotes from '../screens/StickyNotes/reducers';
import assignmentTask from '../screens/AssignmentTask/reducers';
import orders from '../screens/Orders/reducers';
import message from './messageReducer';
import peoplesearch from '../screens/PeopleSearch/reducers/';
import companyspace from '../screens/CompanySpace/reducers/';

export default combineReducers({
  internalLinks,
  linksSetting,
  index,
  companyAdmin,
  companyNews,
  companyRules,
  departmentNews,
  stickynotes,
  assignmentTask,
  orders,
  message,
  peoplesearch,
  companyspace,
});



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/screens/Tube/reducers/index.js
 **/